export function generateRandomSymbols(length: number) {
    var res = "";

    for (let i = 0; i < length; i++) {
        const type = Math.floor(Math.random() * 3);
        var next = "0";

        switch (type) {
            case 0:
                const n = Math.floor(Math.random() * 10) + 48;
                next = String.fromCharCode(n);
                break;
            case 1:
                const bigLetter = Math.floor(Math.random() * 26) + 65;
                next = String.fromCharCode(bigLetter);
                break;
            case 2:
                const littleLetter = Math.floor(Math.random() * 26) + 97;
                next = String.fromCharCode(littleLetter);
                break;
        }

        res += next;
    }

    return res;
}